import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { formatarBRL } from "../../helpers/dinheiro";

const ROTULO_DO_CAMPO = {
	value: "o valor",
	userId: "o responsável",
	columnId: "a coluna",
	status: "a situação",
	dueDate: "o prazo",
	title: "o título",
	organizationId: "a empresa",
	name: "o nome",
	number: "o telefone",
	email: "o e-mail",
	total: "o total",
	discount: "o desconto",
};

// Campos que são dinheiro saem formatados; o resto sai como está. Um "1234.56"
// cru no histórico obriga quem lê a converter de cabeça.
const CAMPOS_DE_DINHEIRO = ["value", "total", "discount"];

const SITUACOES = {
	open: "aberto",
	win: "ganho",
	lose: "perdido",
	draft: "rascunho",
	sent: "enviado",
	viewed: "aberto pelo cliente",
	accepted: "aceito",
	rejected: "recusado",
	expired: "vencido",
};

const legivel = (campo, valor) => {
	if (valor === null || valor === undefined || valor === "") return "vazio";
	if (CAMPOS_DE_DINHEIRO.includes(campo)) return formatarBRL(valor);
	if (campo === "status") return SITUACOES[valor] || valor;
	// Id de responsável, coluna ou empresa: o histórico guarda o id, e trocá-lo
	// pelo nome exigiria carregar entidades que podem nem existir mais.
	if (campo.endsWith("Id")) return `#${valor}`;
	return String(valor);
};

const quando = (iso) => {
	const data = new Date(iso);
	const hoje = new Date();
	const mesmoDia = data.toDateString() === hoje.toDateString();

	return mesmoDia
		? `hoje ${data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}`
		: data.toLocaleString("pt-BR", {
				day: "2-digit",
				month: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
			});
};

// "Pedro mudou o valor de R$ 1.000,00 para R$ 1.500,00 · ontem 14:32".
const HistoricoDeMudancas = ({ entity, entityId }) => {
	const [linhas, setLinhas] = useState([]);
	const [carregando, setCarregando] = useState(true);

	useEffect(() => {
		if (!entityId) return;

		(async () => {
			setCarregando(true);
			try {
				const { data } = await api.get(`/history/${entity}/${entityId}`);
				setLinhas(Array.isArray(data) ? data : []);
			} catch (err) {
				toastError(err);
			}
			setCarregando(false);
		})();
	}, [entity, entityId]);

	if (carregando) {
		return (
			<div className="flex justify-center py-4">
				<Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
			</div>
		);
	}

	if (linhas.length === 0) {
		return (
			<p className="py-4 text-center text-xs text-muted-foreground">
				Nada mudou ainda. Daqui para a frente, alteração de valor, responsável,
				coluna e situação fica registrada aqui.
			</p>
		);
	}

	return (
		<div className="space-y-1.5">
			{linhas.map((linha) => (
				<p key={linha.id} className="text-xs leading-relaxed">
					<span className="font-medium">{linha.user?.name || "O sistema"}</span>{" "}
					mudou {ROTULO_DO_CAMPO[linha.field] || linha.field} de{" "}
					<span className="font-medium">
						{legivel(linha.field, linha.oldValue)}
					</span>{" "}
					para{" "}
					<span className="font-medium">
						{legivel(linha.field, linha.newValue)}
					</span>{" "}
					<span className="text-muted-foreground">· {quando(linha.createdAt)}</span>
				</p>
			))}
		</div>
	);
};

export default HistoricoDeMudancas;
